/** Section schema for a given section type, or null. */
export function getSectionSchema(schemas, sectionType) {
  return schemas?.sections?.[sectionType] ?? null;
}

/** Block definition (within a section schema) for a given block type, or null. */
export function getBlockSchema(schemas, sectionType, blockType) {
  const sectionSchema = getSectionSchema(schemas, sectionType);
  return sectionSchema?.blocks?.find((b) => b.type === blockType) ?? null;
}
